(function () {
  'use strict';

  function initQuickOrder(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var inputs = Array.prototype.slice.call(root.querySelectorAll('.b2b-quick-order__quantity'));
    var bulkBar = root.querySelector('[data-quick-order-bulk]');
    var selectedCount = root.querySelector('[data-selected-count]');
    var liveRegion = root.querySelector('[data-quick-order-live]');
    var filterForm = root.querySelector('[data-quick-order-filters]');

    function selectedItems() {
      return inputs.filter(function (input) {
        return !input.disabled && Number(input.value) > 0;
      });
    }

    function updateBulkBar() {
      if (!bulkBar) return;
      var count = selectedItems().length;
      selectedCount.textContent = count;
      bulkBar.hidden = count === 0;
    }

    function validate(input) {
      var quantity = Number(input.value);
      var minimum = Number(input.dataset.minimum || 1);
      var step = Number(input.step || 1);
      var maximum = input.max ? Number(input.max) : null;

      if (!Number.isInteger(quantity) || quantity < minimum || (maximum && quantity > maximum) || (quantity - minimum) % step !== 0) {
        input.setCustomValidity('Enter a quantity that follows the minimum, maximum, and increment shown.');
        input.reportValidity();
        return false;
      }
      input.setCustomValidity('');
      return true;
    }

    function announce(message, isError) {
      liveRegion.textContent = message;
      liveRegion.classList.toggle('is-error', Boolean(isError));
    }

    function setLoading(button, loading) {
      if (!button) return;
      if (loading) button.dataset.originalText = button.textContent;
      button.disabled = loading;
      button.classList.toggle('is-loading', loading);
      button.textContent = loading ? 'Adding…' : (button.dataset.originalText || button.textContent);
    }

    function refreshCartCount() {
      return fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('.header-cart__count, [data-quick-order-cart-count]').forEach(function (element) {
            element.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          return cart;
        });
    }

    function addItems(items, button) {
      setLoading(button, true);
      announce('Adding products to your cart…');
      return fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Products could not be added.');
          return refreshCartCount();
        });
      }).then(function () {
        announce(items.length === 1 ? 'Added to cart.' : items.length + ' products added to cart.');
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { items: items } }));
        return true;
      }).catch(function (error) {
        announce(error.message, true);
        return false;
      }).then(function (succeeded) {
        setLoading(button, false);
        return succeeded;
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        input.setCustomValidity('');
        updateBulkBar();
      });
    });

    root.addEventListener('click', function (event) {
      var rowButton = event.target.closest('[data-add-row]');
      if (rowButton) {
        var input = rowButton.closest('[data-quick-order-row]').querySelector('.b2b-quick-order__quantity');
        if (Number(input.value) === 0) input.value = input.dataset.minimum || 1;
        if (validate(input)) addItems([{ id: Number(input.dataset.variantId), quantity: Number(input.value) }], rowButton);
        updateBulkBar();
        return;
      }

      if (event.target.closest('[data-clear-quantities]')) {
        inputs.forEach(function (input) { input.value = 0; input.setCustomValidity(''); });
        updateBulkBar();
        announce('Quantities cleared.');
        return;
      }

      var bulkButton = event.target.closest('[data-add-selected]');
      if (bulkButton) {
        var selected = selectedItems();
        if (!selected.every(validate)) return;
        addItems(selected.map(function (input) {
          return { id: Number(input.dataset.variantId), quantity: Number(input.value) };
        }), bulkButton).then(function (succeeded) {
          if (succeeded) {
            selected.forEach(function (input) { input.value = 0; });
            updateBulkBar();
          }
        });
      }
    });

    if (filterForm) {
      filterForm.addEventListener('submit', function () {
        var query = filterForm.querySelector('[name="q"]');
        if (query && query.value.trim() === '' && filterForm.dataset.collectionUrl) {
          filterForm.action = filterForm.dataset.collectionUrl;
          query.disabled = true;
          filterForm.querySelectorAll('input[name="type"], input[name="options[prefix]"]').forEach(function (input) { input.disabled = true; });
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-b2b-quick-order]').forEach(initQuickOrder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());
